<div class="login-page-container">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6 col-lg-5">
        <div class="login-form-container">
          <div class="form-header text-center mb-4">
            <div class="logo-container mb-3">
              <img src="/img/membertrace-logo-color.png" alt="MemberTrace" class="login-logo" />
            </div>
            <h1 class="form-title mt-primary-text">Welcome Back</h1>
            <p class="form-subtitle">Sign in to your MemberTrace account</p>
          </div>

          <form data-clarity-mask="true" [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
            <div class="mb-3">
              <label class="visually-hidden" for="login-domain">Domain</label>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Domain</mat-label>
                <input matInput id="login-domain" formControlName="domain" placeholder="yourorganization.membertrace.com">
                <mat-error *ngIf="loginForm.get('domain')?.invalid && loginForm.get('domain')?.touched">
                  {{ getErrorMessage('domain') }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="mb-3">
              <label class="visually-hidden" for="login-username">Username</label>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Username</mat-label>
                <input matInput id="login-username" formControlName="username" placeholder="Enter your username">
                <mat-error *ngIf="loginForm.get('username')?.invalid && loginForm.get('username')?.touched">
                  {{ getErrorMessage('username') }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="mb-4">
              <label class="visually-hidden" for="login-password">Password</label>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Password</mat-label>
                <input 
                  matInput
                  id="login-password"
                  [type]="getPasswordType()" 
                  formControlName="password" 
                  placeholder="Enter your password">
                <button 
                  mat-icon-button 
                  matSuffix 
                  type="button"
                  (click)="togglePasswordVisibility()"
                  [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
                  <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
                <mat-error *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
                  {{ getErrorMessage('password') }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="text-center mb-3">
              <button 
                mat-flat-button 
                color="primary" 
                type="submit" 
                [disabled]="isSubmitting || loginForm.invalid"
                class="login-button">
                <span *ngIf="!isSubmitting">Sign In</span>
                <span *ngIf="isSubmitting">Signing In...</span>
              </button>
            </div>

            <div class="text-center">
              <a href="#" class="forgot-password-link" (click)="goToForgotPassword($event)">Forgot your password?</a>
            </div>
          </form>

          <div class="divider my-4">
            <span class="divider-text">or</span>
          </div>

          <div class="text-center">
            <p class="signup-prompt">
              Don't have an account? 
              <a routerLink="/register-organization" class="signup-link">Sign up here</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
